export const HIIVE_JOIN_LOAD_ERROR_MESSAGE = "Failed to load membership plans.";
